import { PartnersScreen } from './partnersScreen';

const props = [];

export const PartnersScreenDirective = (reactDirective) => reactDirective(PartnersScreen, props);
PartnersScreenDirective.$inject = ['reactDirective'];

angular.module('WB.App').directive('partnersScreen', PartnersScreenDirective);
